import MyLoadingSpinner from "Components/MyLoadingSpinner";
import Timeline from "Components/Timeline";
import useScheduleSheet from "Hooks/useScheduleSheet";
import IStyle from "Interfaces/IStyle";
import moment from "moment";
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";


// import Timeline from 'react-calendar-timeline';
// make sure you include the timeline stylesheet or the timeline will not be styled

// import 'react-calendar-timeline/dist/style.css';


const styles:IStyle = {
	cardContainer: {
		display: "flex", 
		flexDirection: "row", 
		flexWrap: "wrap"
	},
	cardGroup: {
		margin: "1em",
		zIndex: 1,
		padding: "0 0.3em 0 0.3em",
		border: "1px solid",
		borderColor: "pink",
	},
	compactCardGroup: {
		margin: "0.1em 1em 0.1em 1em",
		zIndex: 1,
		padding: "0 0.3em 0 0.3em",
		display: "block",
		marginBottom: "auto",
		marginTop: "5px",
		border: "1px dotted"
	},
	card: {
		textAlign: "center",
		display: "block",
		marginBottom: "auto",
		marginLeft: "auto",
		marginRight: "auto",
	},
	spinnerRow: {
		// alignContent: "center",
		// alignItems: "center",
		// alignSelf: "center",
		// textAlign: "center"
		zIndex: 10
	},
	button: {
		marginRight: 5
	},
	buttonLink: {
		margin: 5,
	},
}
const defaultFrom = moment().add(-7, "days").format("YYYY-MM-DD");
const defaultTo = moment().add(30*7, "days").format("YYYY-MM-DD");
function HelpAlert() {
		// <Row>
		// 	<Alert variant="primary">
		// 		<Image src="/img/Emo/YuukaSob.png" />
		// 		<strong>Help!</strong> I need someone to maintain the data sheet for this page as I would not have enough time to maintain it myself. If interested, please contact me. All you need to know are basic spreadsheet skills and how to use images from a publicly accessible place (like Imgur, not Discord). The Banners are automatically populated from my Student Insights so you also do not need to mind that bit.
		// 	</Alert>
		// </Row>
	return (<></>);
}
export default function BannerSummary() {
	const [dateFrom, setDateFrom] = useState(defaultFrom);
	const [dateTo, setDateTo] = useState(defaultTo);
	const schedule = useScheduleSheet({
		from: moment(dateFrom),
		to: moment(dateTo)
	});
	return (<Row>
		<Col>
			<HelpAlert />
			<Row>
				<Col>
					<Row style={styles.filterRow}>
						<Col md={2}>
							<label>Inclusion Date</label>
						</Col>
						<Col>
							<input 
								style={{width:"100%"}}
								type="date"
								placeholder={`From (${defaultFrom})`}
								value={dateFrom}
								onChange={(event)=>{ setDateFrom(event.target.value) }}
							>
							</input>
						</Col>
						<Col xs={1}>-</Col>
						<Col>
							<input 
								style={{width:"100%"}}
								type="date"
								placeholder={`Until (${defaultTo})`}
								value={dateTo}
								onChange={(event)=>{ setDateTo(event.target.value) }}
								>
							</input>
						</Col>
					</Row>
					<hr></hr>
				</Col>
			</Row>
			<Row hidden={schedule.isReady}>
				<Col></Col>
				<Col style={styles.spinnerRow}>
					<MyLoadingSpinner isLoading={!schedule.isReady}/>
				</Col>
				<Col></Col>
			</Row>
			<Row>
				<Col style={styles.cardContainer}>
				<Timeline 
					entries={[...schedule.BANNER, ...schedule.FRR, ...schedule.RAID, ...schedule.OTHERS]}
				/>
				</Col>
			</Row>
		</Col>
	</Row>
	);
}